import React from 'react';
import { FadeIn } from './ui';
const steps = [{
  num: '1',
  title: 'Identificas',
  desc: 'Identificas tu nivel de inflamación con nuestro test de autodiagnóstico inicial.'
}, {
  num: '2',
  title: 'Aplicas',
  desc: 'Aplicas el Ciclado de Cortisol ajustando el orden de tus comidas actuales.'
}, {
  num: '3',
  title: 'Restauras',
  desc: 'Restauras tu ciclo de sueño para que tu cuerpo queme grasa mientras descansas.'
}];
export function HowItWorksSection() {
  return <section className="bg-sage/20 py-20 px-6 md:py-28" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <FadeIn data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy text-center mb-16" data-id="element-104">
            ¿Cómo Funciona?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-105">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-sage/50 z-0" data-id="element-106"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10 text-center" data-id="element-107">
              <div className="w-24 h-24 mx-auto bg-navy text-sage rounded-full flex items-center justify-center text-4xl font-serif font-bold shadow-lg mb-6 border-4 border-cream" data-id="element-108">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-109">
                {step.title}
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed px-4" data-id="element-110">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}